import React, { useEffect, useState } from 'react'
import { Button, Dropdown, Menu, Modal, Tooltip } from 'antd'
import {
    ExportOutlined,
    ImportOutlined,
    PlusOutlined,
    StarOutlined
} from '@ant-design/icons'
import {
    changeSearch,
    onReloadData,
    setHeader
} from '../../../../redux/actions/layout/interaction/action'
import { useDispatch, useSelector } from 'react-redux'
import {
    deleteSalary,
    getAllSalary,
    getExportTemplateSalaryTable,
    getSalaryById,
    putIsClose,
    updateTemplateId
} from '../../../../api/hrm/wage/salary'
import dayjs from 'dayjs'
import { DG_Format_Status } from '../../../../format/Status'

import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { DG_Format_Date } from '../../../../format/date/Date'
import ContextMenuListSalary from './item/ContextMenuList'
import { ModuleId } from '../../../../common/document/data/ModuleId'
import { AppId } from '../../../../common/document/data/AppId'
import { postDocumentAttach } from '../../../../api/common/document'
import TableTitle from '../../../../common/list/components/TableTitle'
import CommonList from '../../../../common/list'
import { TextCell } from '../../../../common/ellipsis/TextCell'
import SimpleDocument from '../../document/SimpleDocument'
import { useTranslation } from 'react-i18next'
import { AbilityUtil } from '../../../../custom/permission/Can'
import { ActionKeys, SubjectName } from '../../../../custom/permission/Ability'
import {
    CONCAT_REF_CODE_BY_CUSTOMER_ID,
    REF_CODE_BY_CUSTOMER_ID,
    REF_CODE_BY_SALARY_CONFIG,
    TYPE_SALARY_CONFIG
} from './item/typeSalaryConfig'
import MenuShiftWork from '../../timekeeping/time-sheet/shift-assignment/items/MenuShiftWork'
import {
    APP_CODE_SALARY,
    MODULE_CODE
} from '../../timekeeping/time-sheet/shift-assignment/items/Constant'
import { changeDataButtonProcess } from '../../../../redux/actions/layout/data/action'
import { DoAvatar } from '@dogoo/do-avatar'
import { useMainAppContext } from '../../../../hooks/useMainAppContext'
import {formatResult, to2Floor} from "../../../../format/Money";
import {useLazyQuery} from "@apollo/client";
import {QUERY_GET_USER_PROFILE_GQL} from "../../../../api/common/profile/profileGql";
import {getIconFromType, getTypeSalary} from "./custom/columnPayrollCustom";

const SalaryList = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const [searchParams] = useSearchParams()
    const [dataSource, setDataSource] = useState([])
    const { filter, search, reloadData, reloadDataButtonProcess } = useSelector(
        (state) => state.layoutInteractionReducer
    )
    const page = searchParams.get('page')
    const pageSize = searchParams.get('pageSize')
    const sort = searchParams.get('sort')
    const [salaryRow, setSalaryRow] = useState(0)
    const [status, setStatus] = useState('draft')
    const [salaryNameValue, setSalaryNameValue] = useState('')
    const [loading, setLoading] = useState(true)
    const [getProfile] = useLazyQuery(QUERY_GET_USER_PROFILE_GQL);
    const getRefByCustomerId = () => {
        const userProfile = localStorage.getItem("userProfile");
        if (userProfile !== null) {
            const json = JSON.parse(userProfile);
            return REF_CODE_BY_CUSTOMER_ID(json?.customerId)
        } else {
            getProfile().then((res) => {
                const data = res?.data?.userProfile
                if (data) {
                    return REF_CODE_BY_CUSTOMER_ID(data?.customerId)
                }
            })
        }
        return uuid4()
    }
    const [totalCount, setTotalCount] = useState(0)
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [documentShow, setShowDocument] = useState(false)
    const [documentShowAll, setShowAllDocument] = useState(false)
    const [type, setType] = useState(false)
    const [externalReferenceCode, setExternalReferenceCode] = useState(getRefByCustomerId())
    const [referenceCodeItem, setReferenceCodeItem] = useState(getRefByCustomerId())
    const [defaultTemplateId, setDefaultTemplateId] = useState(null)
    const [createRole, setCreateRole] = useState(false)
    const [templateId, setTemplateId] = useState({
        salaryId: 0,
        attachTemplateId: 0
    })
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)
    const setWindowDimensions = () => {
        setWindowWidth(window.innerWidth)
    }
    const { allUserInformation } = useMainAppContext()

    useEffect(() => {
        window.addEventListener('resize', setWindowDimensions)
        return () => {
            window.removeEventListener('resize', setWindowDimensions)
        }
    }, [])

    useEffect(() => {
        setCreateRole(
            !AbilityUtil.allow(ActionKeys.CREATE, SubjectName.salaryTable, {})
        )
        dispatch(setHeader(t('tnp.components.salary.text133'), null))
        if (search && search !== '') {
            dispatch(changeSearch(''))
        }
    }, [])

    function getDataSource() {
        setLoading(true)
        getAllSalary(filter, page, pageSize, search, sort)
            .then((response) => {
                setTotalCount(response?.totalCount)
                setDataSource(mapDataSource(response?.items))
            })
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        setDataSource([])
        getDataSource()
        if (reloadDataButtonProcess && reloadDataButtonProcess === 'module') {
            dispatch(changeDataButtonProcess(''))
        }
    }, [
        filter,
        page,
        pageSize,
        search,
        sort,
        reloadData,
        reloadDataButtonProcess
    ])

    let navigate = useNavigate()

    function onClickImport(value) {
        switch (value?.key) {
            case 'import_salary':
                navigate('/hrm/timekeeping/wage/table/manual-add')
                break
            case 'import_history_salary':
                navigate('/hrm/timekeeping/wage/table/import/auditing')
                break
            case 'import_salary_template':
                setExternalReferenceCode(getRefByCustomerId())
                setShowAllDocument(true)
                break

            default:
                break
        }
    }

    function onClickExport(value) {
        switch (value?.key) {
            case 'export_template':
                getExportTemplateSalaryTable(0,t).then((res) => {
                    const url = window.URL.createObjectURL(
                        new Blob([res?.content])
                    )
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', res?.fileName) //or any other extension
                    document.body.appendChild(link)
                    link.click()
                })
                break
            default:
                break
        }
    }

    const menu = (
        <Menu
            onClick={onClickImport}
            items={[
                {
                    key: 'import_salary',
                    label: t('tnp.components.salary.text134')
                },
                {
                    key: 'import_salary_template',
                    label: t('tnp.components.salary.text135')
                },
                {
                    key: 'import_history_salary',
                    label: t('tnp.components.salary.text136')
                }
            ]}
        />
    )

    const menuExport = (
        <Menu
            onClick={onClickExport}
            items={[
                {
                    key: 'export_template',
                    label: t('tnp.components.salary.text137')
                }
            ]}
        />
    )

    function mapChildren(salaryTables) {
        return salaryTables?.map((item) => {
            // const key = `SALARY_${item.id}_${uuid4()}`
            const key = `SALARY_${item.id}` // todo ->  fetch debugger
            return {
                key: key,
                id: item.id,
                creatorName: (
                    <DoAvatar
                        ids={[item?.creatorBrief?.accountId]}
                        data={allUserInformation}
                    />

                ),
                creatorId: item?.creatorBrief?.accountId,

                process: item?.process,
                salaryName: (
                    <Link to={`/hrm/timekeeping/wage/table/view/${item?.id}`}>
                        <Tooltip
                            placement="topLeft"
                            title={getTypeSalary(item?.type,t)}
                        >
                            {item?.salaryName}
                            <sup className={'ml-0.5'}>
                                {getIconFromType(item?.type)}
                            </sup>
                        </Tooltip>
                    </Link>
                ),
                salaryNameValues: item?.salaryName,
                isClose: DG_Format_Status(item?.isClose),
                departmentName: <TextCell text={item?.departmentName} />,
                positionName: <TextCell text={item?.positionName} />,
                totalEmployee: item?.totalEmployee,
                totalSalary: item?.totalSalary &&  to2Floor(formatResult(item?.totalSalary,true,true)
                    ?.toString()
                    ?.replaceAll(",","#")
                    ?.replaceAll(".",",")
                    ?.replaceAll("#",".")),
                createDate: DG_Format_Date(item?.createDate),
                status: item?.isClose,
                salaryConfigId: item?.shiftConfigId,
                externalReferenceCode: item?.externalReferenceCode,
                attachTemplateId: item?.attachTemplateId,
                menu: (
                    <MenuShiftWork
                        rowKey={key}
                        moduleCode={MODULE_CODE}
                        appCode={APP_CODE_SALARY}
                        classPk={item.id}
                        status={item?.isClose}
                        decisionNo={item?.salaryName}
                        creatorId={item?.creatorBrief?.accountId}
                        data={item}
                    />
                )
            }
        })
    }

    const mapDataSource = (values) => {
        if (!values) return
        return values?.map((item,index) => ({
            key: index, //  todo ->  fetch debugger
            creatorName: `${t("casualLeave.label.month")} ${dayjs(item?.yearMonth).format('MM/YYYY')}`,
            children: mapChildren(item?.salaryTables)
        }))
    }

    function uuid4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
            (
                c ^
                (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
            ).toString(16)
        )
    }

    const handleOk = (e) => {
        let value = status === 'approved' ? 'pending' : 'approved'

        switch (e) {
            case 'updateStatus':
                putIsClose(salaryRow, value).then(() => {
                    setIsModalVisible(false)
                    dispatch(onReloadData(!reloadData))
                    if (
                        reloadDataButtonProcess &&
                        reloadDataButtonProcess === 'module'
                    ) {
                        dispatch(changeDataButtonProcess(''))
                    }
                })
                break

            case 'remove':
                deleteSalary(salaryRow).then(() => {
                    setIsModalVisible(false)
                })
                break
            default:
                break
        }
    }

    const handleCancel = (e) => {
        setIsModalVisible(false)
        setShowDocument(false)
        setShowAllDocument(false)
    }

    const handleShowDocument = () => {
        const refs = []

        dataSource?.map((item) =>
            item?.children?.map((i) => {
                refs.push(i?.externalReferenceCode)
            })
        )

        postDocumentAttach({
            externalReferenceCode,
            pkCode: refs,
            metadata: {
                moduleId: ModuleId.SALARY,
                appId: AppId.SALARY.SALARY_TABLE
            }
        }).then((r) => {
            setExternalReferenceCode(getRefByCustomerId())
        })

        setShowDocument(false)
        setShowAllDocument(false)
    }
    const render = (value, record) => {
        if (record?.id) {
            return (
                <Dropdown
                    overlay={
                        <ContextMenuListSalary
                            id={record?.id}
                            setIsModalVisible={setIsModalVisible}
                            status={record?.status}
                            setType={setType}
                            salaryConfigId={record?.salaryConfigId}
                            setShowDocument={setShowDocument}
                            disabled={createRole}
                            creatorId={record?.creatorId}
                        />
                    }
                    trigger={[`contextMenu`]}
                >
                    <div className={'cursor--pointer '}>
                        {value ? (
                            value
                        ) : (
                            <div className={'cursor--pointer '}>
                                &nbsp;&nbsp;&nbsp;
                            </div>
                        )}
                    </div>
                </Dropdown>
            )
        } else {
            return value
        }
    }

    const columns = [
        {
            title: t('tnp.components.salary.text140'),
            dataIndex: 'creatorName',
            key: 'creatorName',
            render,
            width: '12%'
        },
        {
            title: t('tnp.components.salary.text141'),
            dataIndex: 'salaryName',
            key: 'salaryName',
            render,
            width: '13%'
        },
        {
            title: t('tnp.components.salary.text142'),
            dataIndex: 'isClose',
            key: 'isClose',
            render,
            width: '8%'
        },
        {
            title: t('tnp.components.salary.text143'),
            dataIndex: 'departmentName',
            key: 'departmentName',
            render,
            width: '15%'
        },
        {
            title: t('tnp.components.salary.text144'),
            dataIndex: 'positionName',
            key: 'positionName',
            render,
            width: '15%'
        },
        {
            title: t('tnp.components.salary.text145'),
            dataIndex: 'totalEmployee',
            key: 'totalEmployee',
            render,
            align: 'center',
            width: '10%'
        },
        {
            title: t('tnp.components.salary.text146'),
            dataIndex: 'totalSalary',
            key: 'totalSalary',
            render,
            align: 'center',
            width: '10%'
        },
        {
            title: t('tnp.components.salary.text147'),
            dataIndex: 'createDate',
            key: 'createDate',
            render,
            align: 'center',
            width: '8%'
        },
        {
            dataIndex: 'menu',
            width: '9%',
            align: 'right'
        }
    ]

    function renderContentModal() {
        switch (status) {
            case 'approved':
                return t('tnp.components.salary.text204')
            case 'pending':
                return t('tnp.components.salary.text205')
            default:
                break
        }
    }

    return (
        <>
            <TableTitle
                title={t('tnp.components.salary.text133')}
                extra={
                    <div>
                        <Dropdown
                            disabled={createRole}
                            overlay={menu}
                            onClick={(e) => e.preventDefault()}
                        >
                            <a href="/#" onChange={(e) => onClickImport(e)}>
                                <Button
                                    disabled={createRole}
                                    type={'text'}
                                    icon={<ImportOutlined />}
                                >
                                    Import
                                </Button>
                            </a>
                        </Dropdown>
                        <Dropdown
                            overlay={menuExport}
                            onClick={(e) => e.preventDefault()}
                        >
                            <a href="/#" onChange={(e) => onClickImport(e)}>
                                <Button type={'text'} icon={<ExportOutlined />}>
                                    Export
                                </Button>
                            </a>
                        </Dropdown>
                    </div>
                }
            />
            {dataSource && (
                <CommonList
                    expandable={{
                        defaultExpandAllRows: true
                    }}
                    defaultExpandAllRows={true}
                    columns={columns}
                    dataSource={dataSource}
                    totalCount={totalCount}
                    height={'90%'}
                    className={'cursor--pointer '}
                    scroll={{
                        x:
                            windowWidth <= 1366
                                ? '130vw'
                                : 1367 <= windowWidth && windowWidth <= 1865
                                  ? '120vw'
                                  : false
                    }}
                    loading={loading}
                    onRow={(record) => {
                        return {
                            onClick: (event) => {
                                event.preventDefault()
                            },
                            onContextMenu: (event) => {
                                event.preventDefault()
                                if (record?.id) {
                                    getSalaryById(record?.id).then((r) => {
                                        setTemplateId({
                                            salaryId: record?.id,
                                            attachTemplateId:
                                                r?.attachTemplateId
                                        })
                                        setDefaultTemplateId(
                                            r?.attachTemplateId
                                        )
                                        setReferenceCodeItem(r?.externalReferenceCode)
                                        setExternalReferenceCode(
                                            CONCAT_REF_CODE_BY_CUSTOMER_ID([getRefByCustomerId(),REF_CODE_BY_SALARY_CONFIG(r?.shiftConfigReferenceCode || ""),r?.externalReferenceCode ])
                                        )
                                    })

                                    setSalaryRow(record?.id)
                                    setStatus(record?.status)
                                    setSalaryNameValue(record?.salaryNameValues)
                                }
                            }
                        }
                    }}
                />
            )}
            <Modal
                title={t('tnp.button.confirm')}
                onCancel={handleCancel}
                onOk={() => handleOk(type)}
                open={isModalVisible}
                destroyOnClose={true}
                okText={
                    type === 'updateStatus'
                        ? status === 'approved'
                            ? t('tnp.button.unLock')
                            : t('tnp.button.lock')
                        : t('tnp.button.delete')
                }
                cancelText={t('tnp.button.cancelText')}
            >
                <p>
                    {type === 'updateStatus'
                        ? renderContentModal()
                        : t('tnp.components.salary.text148')}
                    <b>{salaryNameValue}</b> {t('tnp.button.no')}{' '}
                </p>
            </Modal>
            <Modal
                title={t('tnp.components.salary.text149')}
                onCancel={handleCancel}
                onOk={() => handleShowDocument()}
                open={documentShow}
                destroyOnClose={true}
                footer={null}
                width={700}
                bodyStyle={{
                    maxHeight: 500,
                    overflowY: 'scroll',
                    overflowX: 'hidden'
                }}
            >
                <SimpleDocument
                    referenceCodeItem={referenceCodeItem}
                    externalReferenceCode={externalReferenceCode}
                    moduleId={ModuleId.SALARY}
                    appId={AppId.SALARY.SALARY_TABLE}
                    accept={'.xlsx'}
                    radioSelect={{
                        value: defaultTemplateId,
                        onChange: (e) => {
                            if (e.target.value && templateId.salaryId) {
                                updateTemplateId(
                                    templateId.salaryId,
                                    e.target.value
                                ).then((r) => {})
                            }

                            setTemplateId({
                                ...templateId,
                                attachTemplateId: e.target.value
                            })
                            setDefaultTemplateId(e.target.value)
                        }
                    }}
                />
            </Modal>
            <Modal
                title={t('tnp.components.salary.text149')}
                onCancel={handleCancel}
                onOk={() => handleShowDocument()}
                open={documentShowAll}
                destroyOnClose={true}
                width={700}
            >
                <SimpleDocument
                    externalReferenceCode={externalReferenceCode}
                    moduleId={ModuleId.SALARY}
                    appId={AppId.SALARY.SALARY_TABLE}
                    accept={'.xlsx'}
                />
            </Modal>
        </>
    )
}
export default SalaryList